import type * as React from 'react';
import { post } from '@Domain/Api';
import type { RolePayload } from '@Application/Security/Roles/Actions/rolesFetched';
import roleCreated, { type RoleCreatedAction } from '@Application/Security/Roles/Actions/roleCreated';
import roleCreationFailed, {
	type RoleCreationFailedAction,
} from '@Application/Security/Roles/Actions/roleCreationFailed';
import type CreateRole from '@Application/Security/Roles/Commands/CreateRole';
import fetchRoles from '@Application/Security/Roles/fetchRoles';
import FetchRoles from '@Application/Security/Roles/Queries/FetchRoles';
import type { RolesFetchedAction } from '@Application/Security/Roles/Actions/rolesFetched';
import type { RolesFetchFailedAction } from '@Application/Security/Roles/Actions/rolesFetchFailed';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = RoleCreatedAction | RoleCreationFailedAction | RolesFetchedAction | RolesFetchFailedAction;

/** The response carries only the new role, so the list is refetched; a failed refetch is ignored. */
export default (command: CreateRole) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<RolePayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/roles`,
				command.toJSON(),
			);

			const action = roleCreated(payload, command.accountId);
			dispatch(action);
			await fetchRoles(new FetchRoles(command.accountId))(dispatch).catch(() => undefined);

			return action;
		} catch (error) {
			const action = roleCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
